import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import UserFooter from "./UserFooter";
import Header from "./Header";
import { fetchDropdownByCategoryWise } from "../../service/DropdownService";
import { apiUrl } from "../../config";

const Attachment = () => {
    const [dropdownList, setDropdownList] = useState([]);
    const [selectedCategory, setSelectedCategory] = useState(null);
    useEffect(() => {
        getCategories();
    }, []);

    const getCategories = async () => {
        try {
            const data = await fetchDropdownByCategoryWise("HealthCare Category");
            const sortedData = data.sort((a, b) => a.title.localeCompare(b.title));
            setDropdownList(sortedData);
        } catch (err) {
            console.error("Failed to fetch dropdown list:", err);
        }
    };
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const fileUrl = queryParams.get("url");

    if (!fileUrl) {
        return <h3 className="text-center mt-5">No file to display</h3>;
    }
    return (
        <>
            {/* <div id="preloader">
        <div id="status">
          <img src="/images/preloader.gif" id="preloader_image" alt="loader" />
        </div>
      </div> */}
            <a href="javascript:;" id="return-to-top">
                <i className="fas fa-angle-double-up"></i>
            </a>
            <Header />
            <div className="container-fluid banner-marquee-container">
                <div className="row marquee-row">
                    <marquee
                        className="marquee-announcement-home-page"
                        behavior="scroll"
                        direction="left"
                        scrollamount="8"
                    >
                        <div style={{ display: "inline-block", whiteSpace: "nowrap" }}>
                            <span role="img" aria-label="announcement" className="fs-5 me-2">
                                📢
                            </span>
                            <span className="fw-bold ">
                                This web vvrhcs has many Healthcare sites to register your name
                                and company please contact us-
                                <a
                                    href="#"
                                    style={{
                                        textDecoration: "none",
                                        color: "#ffffff",
                                        marginLeft: "10px",
                                    }}
                                >
                                    <span>
                                        <i className="fas fa-phone me-2"></i>
                                    </span>
                                    04362 - 238 235
                                </a>
                            </span>
                        </div>
                    </marquee>
                </div>
            </div>
            <div className="blog-page-main-container float_left pt-2">
                <div className="container-fluid">
                    <div className="row">
                        {/* Left Section */}
                        <div className="col-lg-9 col-md-12 col-sm-12 col-12">
                            <div className="blog-single-main-page">
                                <div style={{ height: "100vh", margin: 0 }}>
                                    <iframe
                                        src={`${fileUrl.startsWith("http") ? fileUrl : apiUrl + "/" + fileUrl}#toolbar=0&navpanes=0&view=fitH&zoom=85`}
                                        title="More Details"
                                        style={{
                                            width: "100%",
                                            height: "100%",
                                            border: "none",
                                        }}
                                    />
                                </div>
                            </div>
                        </div>

                        {/* Right Sidebar */}
                        <div className="col-lg-3 col-md-12 col-sm-12 col-12">
                            <aside className="blog-right-sidebar resp-30">
                                <div
                                    className=" p-4 "
                                    style={{ background: "#00B3FF" }}
                                >
                                    <h4 className="fw-bold mb-4 text-white">CATEGORIES</h4>

                                    <ul className="list-unstyled">
                                        {dropdownList.map((item, index) => (
                                            <CategoryItem
                                                category={item.title}
                                                key={index}
                                                onClick={() => {
                                                    setSelectedCategory(item.title);
                                                    window.scrollTo({ top: 0, behavior: "smooth" });
                                                }}
                                            />
                                        ))}
                                    </ul>
                                </div>
                            </aside>
                        </div>
                    </div>
                </div>
            </div>

            <UserFooter />
        </>
    );
};

export default Attachment;

const CategoryItem = ({ category, onClick }) => (
    <li className="mb-2">
        <div
            className="d-flex align-items-center gap-2"
            role="button"
            onClick={onClick}
        >
            <i className="fas fa-heartbeat fa-1x text-white"></i>
            <Link
                to={`/category/${category}`}
                className=" text-white text-decoration-none"
            >
                {category}
            </Link>
        </div>
    </li>
);
